module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Regular.b5004973.woff2";